import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, ShieldCheck, MapPin, Clock } from 'lucide-react';

const CTASection = ({ onGetQuote }) => {
  return (
    <section className="py-16 md:py-24 bg-amber-500 relative overflow-hidden" aria-label="Get a Dog Boarding Quote Baltimore">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {[
            { icon: ShieldCheck, text: 'Background Checked' },
            { icon: MapPin, text: 'Locally Owned' },
            { icon: Clock, text: '5+ Years Trusted' }
          ].map((badge, index) => (
            <div key={index} className="flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
              <badge.icon className="w-4 h-4 text-white" aria-hidden="true" />
              <span className="text-white text-sm font-medium">{badge.text}</span>
            </div>
          ))}
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready for the Best Dog Boarding in Baltimore?
        </h2>
        <p className="text-lg md:text-xl text-amber-100 mb-8 max-w-2xl mx-auto">
          Join 50+ Baltimore families who trust us with their furry friends. Get your personalized <strong className="text-white">dog boarding quote</strong> today – it's free!
        </p>

        <Button
          onClick={onGetQuote}
          className="bg-white text-amber-600 hover:bg-amber-50 font-bold px-10 py-7 text-lg rounded-xl shadow-xl hover:shadow-2xl transition-all group"
        >
          Get Your Free Quote
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </Button>

        <p className="mt-6 text-amber-100 text-sm">
          No commitment required • Response within 24 hours
        </p>
      </div>
    </section>
  );
};

export default CTASection;
